import * as type from "../types";

const initialState = {
  marketMatches: [],
  marketMatchesBuyerOrganization: null,
  marketMatchesSellerOrganization: null,
  loading: false,
  error: false,
  activeOffers: [],
  activeOffersLoading: false,
  activeOffersError: false,
  systemParticipantMatches: [],
  systemParticipantMatchesForMarketResult: [],
  systemParticipantOffers: [],
  systemParticipantMatchesLoading: false,
  systemParticipantMatchesError: false,
  cancalledMatchCertificate: null,
  marketMatchesForMarketResult: [],
};

export default function offers(state = initialState, action) {
  switch (action.type) {
    case type.GET_MARKET_MATCHES_REQUESTED:
      return {
        ...state,
        loading: true,
        error: false,
        marketMatchesForMarketResult: [],
      };
    case type.GET_MARKET_MATCHES_SUCCEEDED:
      return {
        ...state,
        marketMatches: action.payload?.marketMatches,
        marketMatchesForMarketResult: action?.payload?.isMarketResult
          ? action.payload?.marketMatches
          : [],
        loading: false,
        error: false,
      };
    case type.GET_MARKET_MATCHES_FAILED:
      return {
        ...state,
        marketMatches: [],
        marketMatchesForMarketResult: [],
        loading: false,
        error: true,
      };
    case type.GET_ACTIVE_OFFERS_REQUESTED:
      return {
        ...state,
        activeOffersLoading: true,
        activeOffersError: false,
      };
    case type.GET_ACTIVE_OFFERS_SUCCEEDED:
      return {
        ...state,
        activeOffers: action.payload,
        activeOffersLoading: false,
        activeOffersError: false,
      };
    case type.GET_ACTIVE_OFFERS_FAILED:
      return {
        ...state,
        activeOffers: [],
        activeOffersLoading: false,
        activeOffersError: true,
      };
    case type.SET_MARKET_MATCHES_BUYER_ORGANIZATION:
      return {
        ...state,
        marketMatchesBuyerOrganization: action.payload,
      };
    case type.SET_MARKET_MATCHES_SELLER_ORGANIZATION:
      return {
        ...state,
        marketMatchesSellerOrganization: action.payload,
      };
    case type.GET_SYSTEM_PARTICIPANT_MATCHES_REQUESTED:
      return {
        ...state,
        systemParticipantMatchesLoading: true,
        systemParticipantMatchesError: false,
        systemParticipantMatches: [],
      };
    case type.GET_SYSTEM_PARTICIPANT_MATCHES_SUCCEEDED:
      return {
        ...state,
        systemParticipantMatches: action.payload,
        systemParticipantMatchesForMarketResult: action.payload.isMarketResult
          ? action.payload
          : [],
        systemParticipantMatchesLoading: false,
        systemParticipantMatchesError: false,
      };
    case type.GET_SYSTEM_PARTICIPANT_MATCHES_FAILED:
      return {
        ...state,
        systemParticipantMatches: [],
        systemParticipantMatchesLoading: false,
        systemParticipantMatchesError: true,
      };
    case type.GET_SYSTEM_PARTICIPANT_OFFERS_REQUESTED:
      return {
        ...state,
        systemParticipantMatchesLoading: true,
        systemParticipantMatchesError: false,
      };
    case type.GET_SYSTEM_PARTICIPANT_OFFERS_SUCCEEDED:
      return {
        ...state,
        systemParticipantOffers: action.payload,
        systemParticipantMatchesLoading: false,
        systemParticipantMatchesError: false,
      };
    case type.GET_SYSTEM_PARTICIPANT_OFFERS_FAILED:
      return {
        ...state,
        systemParticipantOffers: [],
        systemParticipantMatchesLoading: false,
        systemParticipantMatchesError: true,
      };
    case type.SEND_MARKET_CANCELLED_MATCHES_REQUESTED:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case type.SEND_MARKET_CANCELLED_MATCHES_SUCCEEDED:
      return {
        ...state,
        cancalledMatchCertificate: action.payload,
        loading: false,
        error: false,
      };
    case type.SEND_MARKET_CANCELLED_MATCHES_FAILED:
      return {
        ...state,
        cancalledMatchCertificate: action.payload,
        loading: false,
        error: true,
      };
    case type.RESET_INITIAL_STATE:
      return {
        ...state,
        marketMatchesForMarketResult: [],
      };
    default:
      return state;
  }
}
